<template>
  <div
    :class="{
      active: isActivePropsElement(element),
      'is-absolute': isAbsolute,
    }"
    class="edit-mode-tool-wrapper"
  >
    <ul
      class="edit-mode-tools d-flex align-items-center justify-center list-unstyled"
    >
      <li>
        <i
          class="far fa-trash-alt me-1"
          @click.stop="$emit('removeElement', element)"
        ></i>
      </li>
      <li>
        <i
          class="far fa-clone"
          v-if="!isOneTimeElement"
          @click.stop="$emit('duplicateElement', element)"
        ></i>
      </li>
      <li>
        <generalDropdown
          :isCaretVisible="false"
          class="task-tools-more-dropdown"
          ref="taskToolsMoreDropdown"
          uniqueReferenceId="insertNewElementDropdown"
        >
          <template v-slot:iconContainer>
            <i class="fas fa-ellipsis-h ellipsis-icon"></i
          ></template>
          <template v-slot:optionData>
            <b-dropdown-item
              @click.stop="$emit('insertNewElement', element.id, 'top')"
              >oben einfügen
            </b-dropdown-item>
            <b-dropdown-item
              @click.stop="$emit('insertNewElement', element.id, 'bottom')"
              >unten einfügen</b-dropdown-item
            >
          </template>
        </generalDropdown>
      </li>
    </ul>
  </div>
</template>
<script>
import GeneralDropdown from '@/components/core/general-dropdown.vue';
export default {
  name: 'FormElementTools',
  props: {
    element: {
      type: Object,
      required: true,
    },
    isActivePropsElement: {
      type: Function,
      default: () => false,
    },
    isAbsolute: {
      type: Boolean,
      default: true,
    },
    singleInstanceElementTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isOneTimeElement() {
      return this.singleInstanceElementTypes.includes(this.element?.type);
    },
  },
  components: {
    GeneralDropdown,
  },
};
</script>
<style scoped>
.edit-mode-tool-wrapper {
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 50;
  transition: all 300ms ease-in-out;
}

.edit-mode-tool-wrapper.is-absolute {
  background: #ededed82 !important;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.edit-mode-tool-wrapper.active,
.form-field-card .form-field.prevent-pointer:hover > .edit-mode-tool-wrapper {
  display: flex;
}
.form-field-card .form-field.prevent-pointer:hover > .edit-mode-tool-wrapper {
  z-index: 51;
}

.form-field-card
  .form-field:has(> .open-toggle-list).prevent-pointer:hover
  > .edit-mode-tool-wrapper {
  display: none !important;
}

.form-field-card
  .form-field:has(> .form-wrapper-element).prevent-pointer:hover
  > .edit-mode-tool-wrapper {
  display: none !important;
}

.form-field-card .form-field .edit-mode-tool-wrapper.active .edit-mode-tools {
  visibility: hidden;
}
.form-field-card
  .form-field.prevent-pointer:hover
  > .edit-mode-tool-wrapper
  .edit-mode-tools {
  visibility: visible !important;
}

.form-field-card .edit-mode-tools {
  padding: 0;
  margin: 0;
}
.form-field-card .edit-mode-tools i {
  font-size: 18px;
  margin: 0;
  color: rgb(103 96 96);
}
.form-field-card .edit-mode-tools li {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-field-card .edit-mode-tools .task-tools-more-dropdown ::v-deep button {
  margin-left: 5px;
  box-shadow: none;
}
.form-field-card .edit-mode-tools ::v-deep .dropdown-menu {
  padding: 8px;
  min-width: 0px;
}
</style>
